import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { getPatientDataByURl, PatientPersonalInfo } from 'src/app/models/verifypatient/verifypatient';
import { NgxSpinnerService } from 'ngx-spinner';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { IntakeService } from 'src/app/services/intake.service';
import { IntakeCheckinSetting } from 'src/app/models/intake/intake';
import { IntakeFieldsSetting } from 'src/app/models/intake/intakeAllergies';

import { SymptommsModel } from 'src/app/models/careteam/careteam';
import { CareTEamService } from '../../../services/care-team.service';
import { TranslateService } from '@ngx-translate/core';
import { PaymentDeiails } from 'src/app/models/registeration/payment_models';
import { PaymentService } from '../../../services/payment.service';
declare var $: any;
@Component({
  selector: 'app-intake',
  templateUrl: './intake.component.html',
  styleUrls: ['./intake.component.css']
})
export class IntakeComponent implements OnInit {
  pageNum: any;
  totalPages: any;
  url: any;
  intakeCheckinSetting: IntakeCheckinSetting = new IntakeCheckinSetting();
  patientPersonalInfo: PatientPersonalInfo;
  newPatientPersonalInfo: getPatientDataByURl;
  intakeFieldsSetting: IntakeFieldsSetting = new IntakeFieldsSetting();
  activeTabsCount: any = 0;
  isFirsttab: boolean = false;
  IsNotMadisonPages: boolean = true;
  sympTomsModel!: SymptommsModel;
  isDue: boolean = false;
  paymentDetials: PaymentDeiails = new PaymentDeiails();
  testing: boolean = false;
  isPaymentEnable: boolean = false;
  landFromCheckin: any;
  isFromNewPatient: boolean = false;
  reasonName: any='';
  PracticeCode: any;
  PatientAccount: any;

  @ViewChild('scrollintake') private myScrollContainer: ElementRef;
  constructor(private translateService: TranslateService, private service: IntakeService, private spinner: NgxSpinnerService, private phrUtils: PhrutillsService, private router: Router, private careTeamService: CareTEamService, private paymentService: PaymentService) {
    this.landFromCheckin = localStorage.getItem("landFrom");
    //console.log("landFromCheckin in intake component", this.landFromCheckin);

    if (this.landFromCheckin == 'drsiteintake') {
      let info = localStorage.getItem('PatientInfo');
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
    }
    else {
      let info = localStorage.getItem('PersonalInfo');
      //console.log("info in intake form", info);
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
     const reason = localStorage.getItem('reason');
      if (reason == null || reason == undefined) {
        this.reasonName = '';
      } else {
        this.reasonName = reason;
      }
      this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
    }
    if (this.landFromCheckin == 'new_patient') {
      this.isFromNewPatient = true;
    }
    if (this.landFromCheckin == 'drsiteintake') {
      let info = localStorage.getItem('PatientInfo');
      if (!info) {
        this.router.navigateByUrl("/");
        return;
      }
      this.newPatientPersonalInfo = this.phrUtils.decrypt(info) as getPatientDataByURl;
      //console.log("info in intake form PatientInfo drsite", this.newPatientPersonalInfo);
      this.reasonName = this.newPatientPersonalInfo.reasonName;
      this.PracticeCode = this.newPatientPersonalInfo.practiceCode;
      this.PatientAccount = this.newPatientPersonalInfo.patientAccount;
    }
    else {
      if (this.isFromNewPatient) {
        let info = localStorage.getItem('PatientInfo');
        if (!info) {
          this.router.navigateByUrl("/");
          return;
        }
        this.newPatientPersonalInfo = this.phrUtils.decrypt(info) as getPatientDataByURl;
        //console.log("newPatientPersonalInfo new pat", this.newPatientPersonalInfo);
        this.reasonName = this.newPatientPersonalInfo.reasonName;
        this.PracticeCode = this.newPatientPersonalInfo.practiceCode;
        this.PatientAccount = this.newPatientPersonalInfo.patientAccount;
      }
      else {
        let info = localStorage.getItem('PersonalInfo');
        //console.log("info in intake form", info);
        if (!info) {
          this.router.navigateByUrl("/");
          return;
        }
        this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
        //console.log("patientPersonalInfo new else", this.patientPersonalInfo);
        //this.reasonName = this.patientPersonalInfo.REASON_NAME;
        if (this.patientPersonalInfo.REASON_NAME) {
          console.log("inside ds reason");
          this.reasonName = this.patientPersonalInfo.REASON_NAME;
        } else {
          console.log("inside ws reason");
          this.reasonName = this.reasonName;
        }
        this.PracticeCode = this.patientPersonalInfo.PRACTICE_CODE;
        this.PatientAccount = this.patientPersonalInfo.PATIENT_ACCOUNT;
      }
    }
    //console.log(this.reasonName,"reason name for madison");
    if (this.reasonName.toLowerCase().includes("madison")) {
      this.IsNotMadisonPages = true;
      //let pagesorder=localStorage.getItem('pagesorder');
      //this.pageNum =JSON.parse(pagesorder?pagesorder:'').intake;
      this.totalPages = localStorage.getItem('totalPages');
    }
    else {
      if (this.service.subsNextStepSurgicalHistory == undefined) {
        this.service.subsNextStepSurgicalHistory = this.service.
          invokeNextStepSurgicalHistory.subscribe((name: string) => {
            this.onNextStepSurgicalHistory();
          });
      }
      if (this.service.subsNoKnown == undefined) {
        this.service.invokeNoKnown.subscribe((name: string) => {
          this.nextIntake();
        });
      }
      this.IsNotMadisonPages = true;
      // let pagesorder = localStorage.getItem('pagesorder');
      // this.pageNum = JSON.parse(pagesorder ? pagesorder : '').intake;
      this.totalPages = localStorage.getItem('totalPages');
    }
  }
  appointmentId: any;
  isPharmacy: boolean = true;
  ngOnInit(): void {
    const apptid = localStorage.getItem("apptId")
    // //console.log("appointment id  ", apptid);
    if (apptid == null || apptid == undefined || apptid == '') {
      this.appointmentId = '';
    } else {
      this.appointmentId = apptid;
      // //console.log("inside appointment id  ", apptid);
    }

    const isBreezePaymentEnabled = localStorage.getItem("isBreezePaymentEnabled");
    //console.log("isBreezePaymentEnabled in intake component  ", isBreezePaymentEnabled);

    if (isBreezePaymentEnabled == null || isBreezePaymentEnabled == undefined || isBreezePaymentEnabled == '') {
      this.isPaymentEnable = false;
    } else {
      if (isBreezePaymentEnabled == "1")
        this.isPaymentEnable = true;
      else
        this.isPaymentEnable = false;
      // //console.log("inside appointment id  ", apptid);
    }


    this.GetIntakeformFieldsSettings();
    let dummyurl = window.location.href.split('/');
    this.url = dummyurl[dummyurl.length - 1];

    this.sympTomsModel = new SymptommsModel();
    this.sympTomsModel.visitReason = this.reasonName.toLowerCase();
    this.sympTomsModel.feverOrChills = "false";
    this.sympTomsModel.cough = "false";
    this.sympTomsModel.shortnessOfBreathDifficultyBreathing = "false";
    this.sympTomsModel.fatigue = "false";
    this.sympTomsModel.muscleOrBodyAches = "false";
    this.sympTomsModel.headache = "false";
    this.sympTomsModel.newLossOfTasteOrSmell = "false";
    this.sympTomsModel.soreThroat = "false";
    this.sympTomsModel.congestionOrRunnyNose = "false";
    this.sympTomsModel.nauseaOrVomiting = "false";
    this.sympTomsModel.diarrhea = "false";
    this.sympTomsModel.diagnosedOrSuspected = "false";
    this.sympTomsModel.travelOutSideNjLastTwoWeak = "false";
    //this.phrUtils.setTitle('Medical History');
    this.getPaymentDetails();
    //console.log('due ', this.isDue);

    /*
    const testing = localStorage.getItem("testing");
    if (localStorage.getItem("testing") == 'payment') {
      this.testing = true
      //console.log("testing ", this.testing);
      //console.log("testing storage", localStorage.getItem("testing"));
    }
    */
    /*const practiceCode = localStorage.getItem("pcode");
    //console.log("practice Code ", practiceCode);
    if (practiceCode == '100') {
      this.isPaymentEnable = true;
    }*/
  }
  enablePayment() {

    if (this.isPaymentEnable) {
      if (this.isDue) {
        this.router.navigateByUrl("patient/payment-overview");
      } else {
        localStorage.setItem("noIntakeForm", "true");
        this.router.navigateByUrl('patient/thank-you');
      }
    } else {
      localStorage.setItem("noIntakeForm", "true");
      this.router.navigateByUrl('patient/thank-you');
    }
    /*
    if (this.testing) {
        this.router.navigateByUrl("patient/payment-overview");
      } else {
        localStorage.setItem("noIntakeForm", "true");
        this.router.navigateByUrl('patient/thank-you');
      }
      */
  }
  getIntakeSettings() {
    this.spinner.show();
    this.service.getCheckinFormSetting(this.PatientAccount, this.PracticeCode)
      .subscribe((res: any) => {
        this.spinner.hide();
        this.intakeCheckinSetting = res as IntakeCheckinSetting;
        if (this.intakeCheckinSetting.statusCode == 200 && this.intakeCheckinSetting.message.toLowerCase() != "no templete found") {
          if (this.intakeCheckinSetting.data.isAllergies != "False") {
            this.isFirsttab = true;
            this.router.navigateByUrl("/patient/intake/allergy");
            this.url = "allergy";
          }
          else {
            this.activeTabsCount++;
          }
          if (this.intakeCheckinSetting.data.isMedicationHistory != "False") {
            if (!this.isFirsttab) {
              this.isFirsttab = true;
              this.router.navigateByUrl("/patient/intake/medication");
              this.url = "medication";
            }
          } else {
            this.activeTabsCount++;
          }
          if (this.intakeCheckinSetting.data.isFamilyHistory != "False") {
            if (!this.isFirsttab) {
              this.isFirsttab = true;
              this.router.navigateByUrl("/patient/intake/family-history");
              this.url = 'family-history';
            }
          } else {
            this.intakeCheckinSetting.data.isSocialHistory = 'False';
            this.activeTabsCount++;
          }

          if (this.intakeFieldsSetting.isShowSocialHistoryTabs) {
            if (!this.isFirsttab) {
              this.isFirsttab = true;
              this.router.navigateByUrl("/patient/intake/social-history");
              this.url = 'social-history';
            }
          } else {
            this.activeTabsCount++;
          }
          if (this.intakeFieldsSetting.isSurgicalHistory) {
            this.intakeCheckinSetting.data.isSurgicalhistory = 'True';
            if (!this.isFirsttab) {
              this.isFirsttab = true;
              this.router.navigateByUrl("/patient/intake/past-surgical-history");
              this.url = 'past-surgical-history';
            }
          } else {
            this.intakeCheckinSetting.data.isSurgicalhistory = 'False';
            this.activeTabsCount++;
          }
          ////console.log(this.intakeFieldsSetting.isPastHospitalization + " past hospital");
          if (this.intakeFieldsSetting.isPastHospitalization) {
            this.intakeCheckinSetting.data.isPasthospitilization = 'True';
            if (!this.isFirsttab) {
              this.isFirsttab = true;
              this.router.navigateByUrl("/patient/intake/past-hospitalization-history");
              this.url = 'past-hospitalization-history';
            }
          } else {
            this.intakeCheckinSetting.data.isPasthospitilization = 'False';
            this.activeTabsCount++;
          }

          //if (this.intakeCheckinSetting.data.showIntakeForm == "0" || this.activeTabsCount==6) { 
          if (this.activeTabsCount == 6) {
            if (localStorage.getItem("backFromCovid") == "true")
              if (this.PracticeCode == '111') {
                this.router.navigateByUrl('patient/updateinfo');
              }

              else if (this.landFromCheckin == 'drsiteintake') {
                this.router.navigateByUrl("/insurance");
              }
              else {
                this.router.navigateByUrl("patient/insurance");
              }
            //this.router.navigateByUrl('patient/visit-reason');
            else {
              this.enablePayment();
            }

          }
          //else {
          //for pages order check and update
          //let pagesorder = localStorage.getItem('pagesorder');
          //let pageNum = JSON.parse(pagesorder ? pagesorder : '');
          //if (pageNum.intake == '' || pageNum.intake == '0') {
          //pageNum.intake = localStorage.getItem('totalPages');
          //pageNum.covid_form = (+pageNum.intake + 1).toString();
          //localStorage.setItem('pagesorder', JSON.stringify(pageNum));
          //let totalPages = localStorage.getItem('totalPages');
          //localStorage.setItem('totalPages', (+(totalPages ? totalPages : '') + 1).toString());
          //let pagesorder = localStorage.getItem('pagesorder');
          //this.pageNum = JSON.parse(pagesorder ? pagesorder : '').intake;
          //this.totalPages = localStorage.getItem('totalPages');
          //}
          //}
        }
        else {
          if (localStorage.getItem("backFromCovid") == "true")
            if (this.PracticeCode == '111') {
              this.router.navigateByUrl('patient/updateinfo');
            } else {
              this.router.navigateByUrl("patient/insurance");
            }
          //this.router.navigateByUrl('patient/visit-reason');
          else {
            this.enablePayment();
          }
        }
      }, (error: any) => {
        this.spinner.hide()
        //this.phrUtils.showError("Service is not available, please try later.");
        if (localStorage.getItem("backFromCovid") == "true")
          if (this.PracticeCode == '111') {
            this.router.navigateByUrl('patient/updateinfo');
          } else {
            this.router.navigateByUrl("patient/insurance");
          }
        //this.router.navigateByUrl('patient/visit-reason');
        else {
          this.enablePayment();
        }
      });
  }
  GetIntakeformFieldsSettings() {
    this.spinner.show();
    this.service.GetIntakeForms(this.PatientAccount, this.PracticeCode).subscribe((res: any) => {

      this.spinner.hide();
      if (res.statusCode == 200 && res.message == "Intake Form Templete") {

        res.data.predefinedForms.map((item: any) => {

          if (item.frontLabel == "Search Allergy")
            this.intakeFieldsSetting.isSearchAllergy = true;
          if (item.frontLabel == "Allergy Type")
            this.intakeFieldsSetting.isAllergytype = true;
          if (item.frontLabel == "Reaction")
            this.intakeFieldsSetting.isReaction = true;
          if (item.frontLabel == "Severity")
            this.intakeFieldsSetting.isSeverity = true;
          if (item.frontLabel == "Observation Date")
            this.intakeFieldsSetting.isObservationDate = true;
          if (item.frontLabel == "End Date")
            this.intakeFieldsSetting.isEndDate = true;
          if (item.frontLabel == "Comments")
            this.intakeFieldsSetting.isComments = true;

          // Medication settings
          if (item.frontLabel == "Medication Intake Schedule")
            this.intakeFieldsSetting.isIntakeAllowed = true;
          if (item.frontLabel == "Diagnosis" && item.sectionName == "Medications")
            this.intakeFieldsSetting.isDiagnosisAllowed = true;

          // Social history
          if (item.frontLabel == "Tobacco Status" && item.sectionName == "Social History") {
            this.intakeFieldsSetting.isSocialHistoryAllowed = true;
            this.intakeFieldsSetting.IsTobaccoAllowed = true;
          }
          if (item.frontLabel == "Effective From" && item.sectionName == "Social History") {
            this.intakeFieldsSetting.isSocialHistoryAllowed = true;
            this.intakeFieldsSetting.IsTobaccoFromAllowed = true;
          }
          if (item.frontLabel == "Effective To" && item.sectionName == "Social History") {
            this.intakeFieldsSetting.isSocialHistoryAllowed = true;
            this.intakeFieldsSetting.IsTobaccoToAllowed = true;
          }
          if (item.frontLabel == "Alcohol Usage/Day" && item.sectionName == "Social History") {
            this.intakeFieldsSetting.isSocialHistoryAllowed = true;
            this.intakeFieldsSetting.IsAlcoholUsagePerDayAllowed = true;
          }
          if (item.frontLabel == "How Long Using Tobacco" && item.sectionName == "Social History") {
            this.intakeFieldsSetting.isSocialHistoryAllowed = true;
            this.intakeFieldsSetting.IsNotesAllowed = true;
          }
          // Risk Assessment

          if (item.frontLabel == "Exercise" && item.sectionName == "Risk Assessment") {
            this.intakeFieldsSetting.isRistAssesmentAllowed = true;
            this.intakeFieldsSetting.IsExerciseAllowed = true;
          }
          if (item.frontLabel == "Drug Use" && item.sectionName == "Risk Assessment") {
            this.intakeFieldsSetting.isRistAssesmentAllowed = true;
            this.intakeFieldsSetting.IsDrugUseAllowed = true;
          }
          if (item.frontLabel == "Seatbelt" && item.sectionName == "Risk Assessment") {
            this.intakeFieldsSetting.isRistAssesmentAllowed = true;
            this.intakeFieldsSetting.IsSeatbeltAllowed = true;
          }
          if (item.frontLabel == "Exposure" && item.sectionName == "Risk Assessment") {
            this.intakeFieldsSetting.isRistAssesmentAllowed = true;
            this.intakeFieldsSetting.IsExposureAllowed = true;
          }
          if (item.frontLabel == "Feel Safe At Home" && item.sectionName == "Risk Assessment") {
            this.intakeFieldsSetting.isRistAssesmentAllowed = true;
            this.intakeFieldsSetting.IsSafeAtHomeAllowed = true;
          }


          // Personal Information
          if (item.frontLabel == "Highest Education") {
            this.intakeFieldsSetting.isPersonalInfoAllowed = true;
            this.intakeFieldsSetting.IsHighestEduAllowed = true;
          }
          if (item.frontLabel == "Industry") {
            this.intakeFieldsSetting.isPersonalInfoAllowed = true;
            this.intakeFieldsSetting.IsIndustryAllowed = true;
          }
          if (item.frontLabel == "Effective From" && item.sectionName == "Personal Information") {
            this.intakeFieldsSetting.isPersonalInfoAllowed = true;
            this.intakeFieldsSetting.IsEffectiveFromAllowed = true;
          }
          if (item.frontLabel == "Effective To" && item.sectionName == "Personal Information") {
            this.intakeFieldsSetting.isPersonalInfoAllowed = true;
            this.intakeFieldsSetting.IsEffectiveToAllowed = true;
          }


          // family history
          if (item.frontLabel == "Relationship" && item.sectionName == "Family History")
            this.intakeFieldsSetting.relationship = true;
          if (item.frontLabel == "Name" && item.sectionName == "Family History")
            this.intakeFieldsSetting.IsNameAllowed = true;
          if (item.frontLabel == "Age" && item.sectionName == "Family History")
            this.intakeFieldsSetting.IsAgeAllowed = true;
          if (item.frontLabel == "Diagnosis" && item.sectionName == "Family History")
            this.intakeFieldsSetting.IsDiagnosisAllowedFamily = true;
          if (item.frontLabel == "Age At Onset" && item.sectionName == "Family History")
            this.intakeFieldsSetting.IsAgeOnSetAllowed = true;
          if (item.frontLabel == "Dead" && item.sectionName == "Family History")
            this.intakeFieldsSetting.IsDeceasedAllowed = true;

          //Past Surgical History
          if (item.frontLabel == "Date" && item.sectionName == "Past Surgical History") {
            this.intakeFieldsSetting.isSurgicalHistory = true;
            this.intakeFieldsSetting.isSurgicalDate = true;
          }
          if (item.frontLabel == "Surgical Procedure" && item.sectionName == "Past Surgical History") {
            this.intakeFieldsSetting.isSurgicalHistory = true;
            this.intakeFieldsSetting.isSurgicalProcedure = true;
          }
          if (item.frontLabel == "Place Of Surgery" && item.sectionName == "Past Surgical History") {
            this.intakeFieldsSetting.isSurgicalHistory = true;
            this.intakeFieldsSetting.isSurgicalPlace = true;
          }
          if (item.frontLabel == "Post-Op Complications" && item.sectionName == "Past Surgical History") {
            this.intakeFieldsSetting.isSurgicalHistory = true;
            this.intakeFieldsSetting.isSurgicalComplications = true;
          }

          //Past Hospitalization  History
          if (item.frontLabel == "Hospitalization Date" && item.sectionName == "Past Hospitalization") {
            this.intakeFieldsSetting.isPastHospitalization = true;
            this.intakeFieldsSetting.isPastHospitalizationDate = true;
          }
          if (item.frontLabel == "Hospitalization Reason" && item.sectionName == "Past Hospitalization") {
            this.intakeFieldsSetting.isPastHospitalization = true;
            this.intakeFieldsSetting.isPastHospitalizationReason = true;
          }
          if (item.frontLabel == "Duration" && item.sectionName == "Past Hospitalization") {
            this.intakeFieldsSetting.isPastHospitalization = true;
            this.intakeFieldsSetting.isPastHospitalizationDuration = true;
          }
        });
        // if all three tabs of the social history tab are not active then also hide social history tab
        if (!this.intakeFieldsSetting.isSocialHistoryAllowed && !this.intakeFieldsSetting.isRistAssesmentAllowed && !this.intakeFieldsSetting.isPersonalInfoAllowed) {
          this.intakeFieldsSetting.isShowSocialHistoryTabs = false; // if all three tabs are not active then dont show social history. The isSocial history field does not effect corrctly other are working fine
          //this.showIntakeOrNot();
        } else {
          this.intakeFieldsSetting.isShowSocialHistoryTabs = true;
        }
        localStorage.setItem("intakeformsetting", this.phrUtils.encrypt(this.intakeFieldsSetting));
        this.getIntakeSettings();
      }
    }, (error: any) => {
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError('Service is not available, please try later.');
    });
  }

  nextFromPharmacy() {
    $("#confirm-pharmacy").modal("hide");
    if (this.intakeCheckinSetting.data.isFamilyHistory == "True") {
      this.router.navigateByUrl("/patient/intake/family-history");
      this.url = 'family-history';
    }
    else if (this.intakeFieldsSetting.isShowSocialHistoryTabs) {
      this.router.navigateByUrl("/patient/intake/social-history");
      this.url = 'social-history';
    } else {
      this.enablePayment();
    }

  }
  nextIntake() {

    let url = window.location.href.split('/');
    if (url[url.length - 1] == 'intake' || url[url.length - 1] == 'allergy') {
      if (this.intakeCheckinSetting.data.isMedicationHistory == "True") {
        this.router.navigateByUrl("/patient/intake/medication");
        this.url = 'medication';
      }
      else if (this.intakeCheckinSetting.data.isFamilyHistory == "True") {
        this.router.navigateByUrl("/patient/intake/family-history");
        this.url = 'family-history';
      }
      else if (this.intakeFieldsSetting.isShowSocialHistoryTabs) {
        this.router.navigateByUrl("/patient/intake/social-history");
        this.url = 'social-history';
      } else {
        this.enablePayment();

      }
    }
    else if (url[url.length - 1] == 'medication') {
      const tpharmacy = localStorage.getItem("tpharmacy")
      if (tpharmacy !== null && tpharmacy !== undefined) {
        //console.log(tpharmacy);
        if (tpharmacy == 'yes') {
          this.isPharmacy = true;
        } else {
          this.isPharmacy = false;
        }
      }
      if (this.isPharmacy == false) {
        //console.log("pharmacy no");
        $("#confirm-pharmacy").modal("show");
      } else {
        //console.log("pharmacy yes");
        if (this.intakeCheckinSetting.data.isFamilyHistory == "True") {
          this.router.navigateByUrl("/patient/intake/family-history");
          this.url = 'family-history';
        }
        else if (this.intakeFieldsSetting.isShowSocialHistoryTabs) {
          this.router.navigateByUrl("/patient/intake/social-history");
          this.url = 'social-history';
        } else {
          this.enablePayment();
        }
      }
    }
    else if (url[url.length - 1] == 'family-history') {
      this.scrollToTop(true);
      if (this.intakeFieldsSetting.isShowSocialHistoryTabs) {
        this.router.navigateByUrl("/patient/intake/social-history");
        this.url = 'social-history';
      } else {
        this.enablePayment();
      }
    }
    else if (url[url.length - 1] == 'social-history') {
      this.scrollToTop(true);
      this.service.onSaveSocialHistory();
      this.url = 'past-surgical-history';
    }
    else if (url[url.length - 1] == 'past-surgical-history') {
      this.scrollToTop(true);
      this.service.onNextStepSurgical();
      this.url = 'past-hospitalization-history';
    }
    else if (url[url.length - 1] == 'past-hospitalization-history') {

      if (this.reasonName.toLowerCase().includes("madison")) {
        this.router.navigateByUrl('/madison-thankyou');
      }
      else {
        this.service.onSavePastHospHX();

        if (this.isPaymentEnable) {
          if (this.isDue)
            this.router.navigateByUrl("patient/payment-overview");
        }

        /*
        if (this.testing)
          this.router.navigateByUrl("patient/payment-overview");
        */
      }
    }
  }

  onFinishIntake() {
    if (this.landFromCheckin == 'drsiteintake') {
      this.router.navigateByUrl('/appoin-mes');
    }
    else if (this.landFromCheckin == 'new_patient') {
      //console.log("navigate to appoin-mes from new patient intake");
      this.router.navigateByUrl('/appoin-mes');
    }
    else {
      localStorage.setItem("noIntakeForm", "true");
      this.router.navigateByUrl('patient/thank-you');
    }
  }


  onNextStepSurgicalHistory() {
    this.router.navigateByUrl("/patient/intake/past-surgical-history");
    this.url = 'past-surgical-history';
  }

  previousIntake() {
    const storedIsWithin24Hours = localStorage.getItem('isWithin24Hours');
    const practiceCode = localStorage.getItem('pcode');
    const reason = localStorage.getItem('reason');
    let url = window.location.href.split('/');
    if (url[url.length - 1] == 'intake' || url[url.length - 1] == 'allergy') {
      if (this.reasonName.toLowerCase().includes("madison")) {
        this.router.navigateByUrl("/madison-ref")
      }
      else {
        localStorage.setItem('backfromintake', 'true');
        if (this.PracticeCode == '111') {
          this.router.navigateByUrl('patient/updateinfo');
        }
        else if (this.landFromCheckin == 'drsiteintake') {
          this.router.navigateByUrl("/insurance");
        }
        else {
          this.router.navigateByUrl("patient/insurance");
        }
        /*
        if (practiceCode == '1011163') {
          this.router.navigateByUrl('patient/symptomsquestion');
        } else {
          this.backClick(practiceCode, reason, storedIsWithin24Hours);
        }*/

      }
    }
    else if (url[url.length - 1] == 'medication') {
      if (this.intakeCheckinSetting.data.isAllergies == "True") {
        this.router.navigateByUrl("/patient/intake/allergy");
        this.url = 'allergy';
      }
      else {
        localStorage.setItem('backfromintake', 'true');
        if (this.PracticeCode == '111') {
          this.router.navigateByUrl('patient/updateinfo');
        }
        else if (this.landFromCheckin == 'drsiteintake') {
          this.router.navigateByUrl("/insurance");
        }
        else {
          this.router.navigateByUrl("patient/insurance");
        }
        /*
        if (practiceCode == '1011163') {
          this.router.navigateByUrl('patient/symptomsquestion');
        } else {
          this.backClick(practiceCode, reason, storedIsWithin24Hours);
        }*/
      }
    }
    else if (url[url.length - 1] == 'family-history') {
      if (this.intakeCheckinSetting.data.isMedicationHistory == "True") {
        this.router.navigateByUrl("/patient/intake/medication");
        this.url = 'medication';
      }
      else if (this.intakeCheckinSetting.data.isAllergies == "True") {
        this.router.navigateByUrl("/patient/intake/allergy");
        this.url = 'allergy';
      }
      else {
        localStorage.setItem('backfromintake', 'true');
        if (this.PracticeCode == '111') {
          this.router.navigateByUrl('patient/updateinfo');
        }
        else if (this.landFromCheckin == 'drsiteintake') {
          this.router.navigateByUrl("/insurance");
        }
        else {
          this.router.navigateByUrl("patient/insurance");
        }
        /*
        if (practiceCode == '1011163') {
          this.router.navigateByUrl('patient/symptomsquestion');
        } else {
          this.backClick(practiceCode, reason, storedIsWithin24Hours);
        }*/
      }
    }
    else if (url[url.length - 1] == 'social-history') {
      this.scrollToTop(false);
      if (this.intakeCheckinSetting.data.isFamilyHistory == "True") {
        this.router.navigateByUrl("/patient/intake/family-history");
        this.url = 'family-history';
      }
      else if (this.intakeCheckinSetting.data.isMedicationHistory == "True") {
        this.router.navigateByUrl("/patient/intake/medication");
        this.url = 'medication';
      }
      else if (this.intakeCheckinSetting.data.isAllergies == "True") {
        this.router.navigateByUrl("/patient/intake/allergy");
        this.url = 'allergy';
      }
      else {
        localStorage.setItem('backfromintake', 'true');
        if (this.PracticeCode == '111') {
          this.router.navigateByUrl('patient/updateinfo');
        }
        else if (this.landFromCheckin == 'drsiteintake') {
          this.router.navigateByUrl("/insurance");
        }
        else {
          this.router.navigateByUrl("patient/insurance");
        }
        /*
        if (practiceCode == '1011163') {
          this.router.navigateByUrl('patient/symptomsquestion');
        } else {
          this.backClick(practiceCode, reason, storedIsWithin24Hours);
        }*/
      }
    }
    else if (url[url.length - 1] == 'past-surgical-history') {
      if (this.intakeCheckinSetting.data.isSocialHistory == "True") {
        this.router.navigateByUrl("/patient/intake/social-history");
        this.url = 'social-history';
      }
      else if (this.intakeCheckinSetting.data.isFamilyHistory == "True") {
        this.router.navigateByUrl("/patient/intake/family-history");
        this.url = 'family-history';
      }
      else if (this.intakeCheckinSetting.data.isMedicationHistory == "True") {
        this.router.navigateByUrl("/patient/intake/medication");
        this.url = 'medication';
      }
      else if (this.intakeCheckinSetting.data.isAllergies == "True") {
        this.router.navigateByUrl("/patient/intake/allergy");
        this.url = 'allergy';
      }
      else {
        localStorage.setItem('backfromintake', 'true');
        if (this.PracticeCode == '111') {
          this.router.navigateByUrl('patient/updateinfo');
        }
        else if (this.landFromCheckin == 'drsiteintake') {
          this.router.navigateByUrl("/insurance");
        }
        else {
          this.router.navigateByUrl("patient/insurance");
        }
        /*
        if (practiceCode == '1011163') {
          this.router.navigateByUrl('patient/symptomsquestion');
        } else {
          this.backClick(practiceCode, reason, storedIsWithin24Hours);
        }*/
      }
    }
    else if (url[url.length - 1] == 'past-hospitalization-history') {
      if (this.intakeCheckinSetting.data.isSurgicalhistory == "True") {
        this.router.navigateByUrl("/patient/intake/past-surgical-history");
        this.url = 'past-surgical-history';
      }
      else if (this.intakeCheckinSetting.data.isSocialHistory == "True") {
        this.router.navigateByUrl("/patient/intake/social-history");
        this.url = 'social-history';
      }
      else if (this.intakeCheckinSetting.data.isFamilyHistory == "True") {
        this.router.navigateByUrl("/patient/intake/family-history");
        this.url = 'family-history';
      }
      else if (this.intakeCheckinSetting.data.isMedicationHistory == "True") {
        this.router.navigateByUrl("/patient/intake/medication");
        this.url = 'medication';
      }
      else if (this.intakeCheckinSetting.data.isAllergies == "True") {
        this.router.navigateByUrl("/patient/intake/allergy");
        this.url = 'allergy';
      }
      else {
        localStorage.setItem('backfromintake', 'true');
        if (this.PracticeCode == '111') {
          this.router.navigateByUrl('patient/updateinfo');
        }
        else if (this.landFromCheckin == 'drsiteintake') {
          this.router.navigateByUrl("/insurance");
        }
        else {
          this.router.navigateByUrl("patient/insurance");
        }
        /*
        if (practiceCode == '1011163') {
          this.router.navigateByUrl('patient/symptomsquestion');
        } else {
          this.backClick(practiceCode, reason, storedIsWithin24Hours);
        }*/
      }
    }
  }
  scrollToTop(Type: any): void {
    try {
      if (Type)
        this.myScrollContainer.nativeElement.scrollLeft = this.myScrollContainer.nativeElement.scrollWidth;
      else
        this.myScrollContainer.nativeElement.scrollLeft -= this.myScrollContainer.nativeElement.scrollWidth;
    } catch (err) { }
  }

  backClick(practiceCode: any, reason: any, storedIsWithin24Hours: any) {
    if (practiceCode == '100' && reason == 'Initial Visit') {
      if (storedIsWithin24Hours == 'true') {
        this.router.navigateByUrl("patient/visit-reason");
      }
      else {
        if (this.landFromCheckin == 'drsiteintake') {
          this.router.navigateByUrl("/insurance");
        }
        else {

          this.router.navigateByUrl("patient/insurance");
        }
      }
    }
    else {
      this.router.navigateByUrl("patient/visit-reason");
    }
  }


  getPaymentDetails() {
    this.spinner.show();
    this.paymentService.getPaymentDetails(this.PracticeCode, this.patientPersonalInfo.PATIENT_ACCOUNT, this.appointmentId).subscribe((res: any) => {
      this.spinner.hide();
      if (res && res.statusCode == 200 && res.message == 'SUCCESS' && res.data) {
        this.paymentDetials = res as PaymentDeiails;
        if (Number(this.paymentDetials.data.totalAmount) > 0) {
          this.isDue = true;
          //console.log('inside due ', this.isDue);
        }
      }
    }, (error: any) => {
      this.spinner.hide();
      let text = "Service is not available, please try later.";
      this.translateService.get('Alerts.service_not_available').subscribe((translation: string) => {
        text = translation;
      });
      this.phrUtils.showError(text);
      //this.phrUtils.showError("Service is not available, please try later.");
    });
  }
}
